import { atom, useAtomValue, useSetAtom } from 'jotai';
import sysLangToTranslationLang from 'utils/sysLangToTranslationLang';
import { currentConversationIdState } from './conversation';
import { useCallback } from 'react';
import { useAtomCallback } from 'jotai/utils';

export type LocalId = string;
export interface LocalVideo {
  videoContent?: Conversation.MsgTextVideo['videoContent'];
  status: Resource.UploadState;
  conversationId: string;
  // 上传的时候本地生成一个id，方便本地检索
  localId: LocalId;
  name: string;
  errorText?: string;
  progress?: number;
  resourceId?: string;
  vid?: string;
}

export interface UploadStateChangeEvent {
  msgId: string;
  resourceId: string;
  resourceState: Resource.UploadState | Resource.Message['resourceState'];
  yunXinMsgId: string;
  url: string;
  externalVideoId?: string;
}

const localVideoMapState = atom<Record<LocalId, LocalVideo>>({});

export const useLocalMapVideo = () => useAtomValue(localVideoMapState);
export const useSetLocalMapVideo = () => useSetAtom(localVideoMapState);

export const useSetSingleLocalVideo = () => {
  return useAtomCallback(
    useCallback((get, set, item: Partial<LocalVideo> & { localId: LocalId }, update?: boolean) => {
      const localVideoMap = get(localVideoMapState);
      let next = localVideoMap[item.localId];
      if (!next) {
        if (update) {
          return;
        }
        next = {} as LocalVideo;
      }

      set(localVideoMapState, {
        ...localVideoMap,
        [item.localId]: {
          ...next,
          ...item,
        },
      });
    }, []),
  );
};

export const currentConversationLocalVideo = atom((get) => {
  const localVideoMap = get(localVideoMapState);
  const currentConversationId = get(currentConversationIdState);
  const localVideoList = Object.values(localVideoMap);
  return localVideoList.filter((x) => x.conversationId === currentConversationId);
});

export const useCurrentConversationLocalVideo = () => useAtomValue(currentConversationLocalVideo);

export const trans = {
  'zh-CN': '点击查看视频',
  id: 'Lihat video',
  th: 'ดูวิดีโอ',
  'en-US': 'Watch Video',
  vi: 'Xem video',
  pt: 'Ver vídeo',
  'zh-TW': '觀看視頻',
  tl: 'Panoorin ang video',
  ms: 'Lihat video',
  fr: 'Voir la vidéo',
  pl: 'Pokaż wideo',
  es: 'Ver vídeo',
};
export const getTextVideoTextContent = (
  url: string,
  targetLanguage: General.Language,
): Conversation.MsgTextVideo['textContent'] => {
  const translationContent = Object.entries(trans).reduce((pre, cur) => {
    const [key, value] = cur;
    return {
      ...pre,
      [sysLangToTranslationLang(key as any)]: {
        targetLanguage: sysLangToTranslationLang(key as any),
        text: value,
        source: 'chatpp',
      },
    };
  }, {});
  return {
    text: `${trans[targetLanguage as keyof typeof trans]} ${url}`,
    originalText: trans[targetLanguage as keyof typeof trans],
    translationContent,
  };
};
